import styled from "styled-components";
import css from "@styled-system/css";
import { Button as StreamButton } from "../guide/Stream/styled";
import { Card as InfoCard, Description as InfoDescription } from "./InfoCard";

export const Description = styled(InfoDescription)(
  css({
    fontSize: [1, 2],
    my: 25,
  })
);

export const Button = styled(StreamButton)(
  css({
    fontSize: [2, 3],
    my: 0,
    width: "100%",
    boxSizing: "border-box",
  })
);

export const Card = styled(InfoCard)({
  display: "flex",
  flexDirection: "column",
  padding: 16,
});

export const Picture = styled("img")(
  css({
    borderRadius: 30,
  })
);
